import React, { useRef, useState } from 'react';
import { motion } from 'framer-motion';
import './Drawer.css';
import Card from '../Card/Card';
import { Copy } from 'lucide-react';


const HtmlText = ({ text }) => <>{text}</>;

const Drawer = () => {
  const snippetContainerRef = useRef(null);
  const [showScanning, setShowScanning] = useState(false);

  const copySnippet = () => {
    if (snippetContainerRef.current) {
      const range = document.createRange();
      range.selectNode(snippetContainerRef.current);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();

      setShowScanning(true);
      setTimeout(() => setShowScanning(false), 1000);
    }
  };

  // OPEN universal drawer
  const openDrawer = (e) => {
    const drawerId = e.currentTarget.dataset.drawer;
    const drawer = document.getElementById(drawerId);
    if (!drawer) return;

    drawer.style.display = "block";
    drawer.classList.add("seek");
    document.body.classList.add("freeze");
  };

  // CLOSE universal drawer
  const closeDrawer = (e) => {
    const drawerId = e.currentTarget.dataset.drawer;
    const drawer = document.getElementById(drawerId);
    if (!drawer) return;

    const drawerChild = drawer.querySelector(".carve-drawer-inner");

    drawerChild.classList.add("drawer-hide");
    drawer.classList.add("waneout");

    setTimeout(() => {
      drawer.classList.remove("seek", "waneout");
      drawerChild.classList.remove("drawer-hide");
      drawer.style.display = "none";
      document.body.classList.remove("freeze");
    }, 290);
  };



  // rise drawer copy snippet 

  const riSesnippetContainerRef = useRef(null);
  const [riSeshowScanning, riSesetShowScanning] = useState(false);

  const riSecopySnippet = () => {
    if (riSesnippetContainerRef.current) {
      const range = document.createRange();
      range.selectNode(riSesnippetContainerRef.current);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();

      riSesetShowScanning(true);
      setTimeout(() => riSesetShowScanning(false), 1000);
    }
  };
  const riseDrawer = () => {
    var drawerseek = document.getElementsByClassName('rise')[0];
    drawerseek.classList.add('seek');
    document.body.classList.add('freeze');
  }
  const closeRiseDrawer = () => {
    var drawerseek = document.querySelector('.rise');
    var drawerChild = drawerseek.children[0];
    drawerChild.classList.add('fall');
    drawerseek.classList.add('waneout');
    setTimeout(() => {
      drawerseek.classList.remove('seek');
      drawerChild.classList.remove('fall')
      drawerseek.classList.remove('waneout');
      document.body.classList.remove('freeze');
    }, 290)
  }


  return (

    <motion.div
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      <section>
        <button
          className="carve-button-main"
          data-drawer="listDrawer"
          onClick={openDrawer}
        >
          slide drawer
        </button>
        <div className="carve-drawer" id='listDrawer'>
          <div className="carve-drawer-inner">
            <div className="carve-drawer-head">
              <div className="heading-medium">drawer header</div>
              <button
                className="icon icon-close"
                data-drawer="listDrawer"
                onClick={closeDrawer}
              >
                &times;
              </button>
            </div>
            <div className="carve-drawer-body">
              <ul>
                <li>optin 1</li>
                <li>optin 2</li>
                <li>optin 3</li>
                <li>optin 4</li>
                <li>optin 5</li>
                <li>optin 1</li>
                <li>optin 2</li>
                <li>optin 3</li>
                <li>optin 4</li>
                <li>optin 5</li>
                <li>optin 1</li>
                <li>optin 2</li>
                <li>optin 3</li>
                <li>optin 4</li>
                <li>optin 5</li>
                <li>optin 1</li>
                <li>optin 2</li>
                <li>optin 3</li>
                <li>optin 4</li>
                <li>optin 5</li>
              </ul>
            </div>
          </div>
        </div>
        <div className={`center-container ${showScanning ? 'scanning' : ''}`}>

          <div className='snippet' ref={snippetContainerRef}>
            <pre>
              <code>
                <span className="cn">&lt;button</span>
                <span className="cln"> className="</span><span className="cn">carve-button-main</span><span className="cln">"</span><br />
                &nbsp;&nbsp;<span className="cln"> data-drawer="</span><span className="cn">listDrawer</span><span className="cln">"</span><br />
                &nbsp;&nbsp;<span className="cln"> onclick="</span><span className="cn">openDrawer()</span><span className="cln">"</span><span className="cn">&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;slide drawer<br />
                <span className="cn">&lt;/button&gt;</span><br />
                <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-drawer</span><span class="cln">"</span><span class="cn">&gt;</span><br />
                &nbsp;&nbsp;<span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-drawer-inner</span><span class="cln">"</span><span class="cn">&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-drawer-head</span><span class="cln">"</span><span class="cn">&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">heading-medium</span><span class="cln">"</span><span class="cn">&gt;</span>drawer header<span class="cn">&lt;/div&gt;</span><br />
                <span className="cn">&lt;button</span>
                <span className="cln"> class="</span><span className="cn">icon icon-close</span><span className="cln">"</span><br />
                &nbsp;&nbsp;<span className="cln"> data-drawer="</span><span className="cn">listDrawer</span><span className="cln">"</span><br />
                &nbsp;&nbsp;<span className="cln"> onclick="</span><span className="cn">closeDrawer()</span><span className="cln">"</span><span className="cn">&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&amp;times;<br />
                <span className="cn">&lt;/button&gt;</span><br />

                &nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;/div&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-drawer-body</span><span class="cln">"</span><span class="cn">&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;ul&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;li&gt;</span>option 1<span class="cn">&lt;/li&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;li&gt;</span>option 2<span class="cn">&lt;/li&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;li&gt;</span>option 3<span class="cn">&lt;/li&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;li&gt;</span>option 4<span class="cn">&lt;/li&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;li&gt;</span>option 5<span class="cn">&lt;/li&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;li&gt;</span>option 1<span class="cn">&lt;/li&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;li&gt;</span>option 2<span class="cn">&lt;/li&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;li&gt;</span>option 3<span class="cn">&lt;/li&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;li&gt;</span>option 4<span class="cn">&lt;/li&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;li&gt;</span>option 5<span class="cn">&lt;/li&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;li&gt;</span>option 1<span class="cn">&lt;/li&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;li&gt;</span>option 2<span class="cn">&lt;/li&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;li&gt;</span>option 3<span class="cn">&lt;/li&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;li&gt;</span>option 4<span class="cn">&lt;/li&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;li&gt;</span>option 5<span class="cn">&lt;/li&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;li&gt;</span>option 1<span class="cn">&lt;/li&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;li&gt;</span>option 2<span class="cn">&lt;/li&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;li&gt;</span>option 3<span class="cn">&lt;/li&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;li&gt;</span>option 4<span class="cn">&lt;/li&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;li&gt;</span>option 5<span class="cn">&lt;/li&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;/ul&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;/div&gt;</span><br />
                &nbsp;&nbsp;<span class="cn">&lt;/div&gt;</span><br />
                <span class="cn">&lt;/div&gt;</span><br />

              </code>
            </pre>

          </div>
          <button aria-label="Copy Button" onClick={copySnippet}>
            <Copy />
          </button>

        </div>
      </section>

      <section className='carve-space-top-hefty'>
        <button className="carve-button-main" onClick={riseDrawer}>rise drawer</button>
        <div className="carve-drawer rise">
          <div className="carve-drawer-inner">
            <div className="carve-drawer-head">
              <div className="heading-medium">drawer header</div>
              <button className="icon icon-close" onClick={closeRiseDrawer}>
                &times;
              </button>
            </div>
            <div className="carve-drawer-body">
              <ul>
                <li>optin 1</li>
                <li>optin 2</li>
                <li>optin 3</li>
                <li>optin 4</li>
                <li>optin 5</li>
                <li>optin 1</li>
                <li>optin 2</li>
                <li>optin 3</li>
                <li>optin 4</li>
                <li>optin 5</li>
                <li>optin 1</li>
                <li>optin 2</li>
                <li>optin 3</li>
                <li>optin 4</li>
                <li>optin 5</li>
                <li>optin 1</li>
                <li>optin 2</li>
                <li>optin 3</li>
                <li>optin 4</li>
                <li>optin 5</li>
              </ul>
            </div>
          </div>
        </div>
        <div className={`center-container ${riSeshowScanning ? 'scanning' : ''}`}>

          <div className='snippet' ref={riSesnippetContainerRef}>
            <pre>
              <code>
                <span className="cn">&lt;button</span>
                <span className="cln"> class="</span><span className="cn">carve-button-main</span><span className="cln">"</span><br />
                &nbsp;&nbsp;<span className="cln"> data-drawer="</span><span className="cn">riseDrawer</span><span className="cln">"</span><br />
                &nbsp;&nbsp;<span className="cln"> onclick="</span><span className="cn">riseDrawer()</span><span className="cln">"</span><span className="cn">&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;rise drawer<br />
                <span className="cn">&lt;/button&gt;</span><br />


                <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-drawer rise</span><span class="cln">"</span><span class="cn">&gt;</span><br />
                &nbsp;&nbsp;<span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-drawer-inner</span><span class="cln">"</span><span class="cn">&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-drawer-head</span><span class="cln">"</span><span class="cn">&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">heading-medium</span><span class="cln">"</span><span class="cn">&gt;</span>drawer header<span class="cn">&lt;/div&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;button</span>
                <span className="cln"> class="</span><span className="cn">icon icon-close</span><span className="cln">"</span><br />
                &nbsp;&nbsp;<span className="cln"> data-drawer="</span><span className="cn">riseDrawer</span><span className="cln">"</span><br />
                &nbsp;&nbsp;<span className="cln"> onclick="</span><span className="cn">closeRiseDrawer()</span><span className="cln">"</span><span className="cn">&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&amp;times;<br />
                <span className="cn">&lt;/button&gt;</span><br />


                &nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;/div&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-drawer-body</span><span class="cln">"</span><span class="cn">&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;ul&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;li&gt;</span>option 1<span class="cn">&lt;/li&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;li&gt;</span>option 2<span class="cn">&lt;/li&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;li&gt;</span>option 3<span class="cn">&lt;/li&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;li&gt;</span>option 4<span class="cn">&lt;/li&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;li&gt;</span>option 5<span class="cn">&lt;/li&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;/ul&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;/div&gt;</span><br />
                &nbsp;&nbsp;<span class="cn">&lt;/div&gt;</span><br />
                <span class="cn">&lt;/div&gt;</span><br />

              </code>
            </pre>
          </div>
          <button aria-label="Copy Button" onClick={riSecopySnippet}>
            <Copy />
          </button>
        </div>
      </section>
    </motion.div>
  )
}

const DrawerCard = () => {
  return (
    <Card
      CardTitle={<HtmlText text="Drawer" />}
      CardBody={<Drawer />}
    />
  )
}

export default DrawerCard;